export default __webpack_public_path__ + "static/media/cryogenic-icon.10627d7e.svg";